import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import QuickQuizGame from './QuickQuizGame';
import './quickquizgame.css';

const QuickQuizInvite = () => {
  const { roomNumber, topic_id } = useParams();
  const navigate = useNavigate();
  const [guestName, setGuestName] = useState('');
  const [joinAsGuest, setJoinAsGuest] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  if (!roomNumber) {
    return (
      <div className="quick-quiz-container">
        <div className="message error">
          <h3>Error: Invalid room number provided!</h3>
          <p>Please check your invitation link and try again.</p>
        </div>
      </div>
    );
  }

  const handleJoinAsGuest = () => {
    if (!guestName.trim()) {
      setErrorMessage('Please enter your name to continue');
      return;
    }
    
    setErrorMessage('');
    setJoinAsGuest(true);
  };

  const handlePlayDirectly = () => {
    // Redirect to the game with guest params
    const topicParam = topic_id ? `&topic=${topic_id}` : '';
    navigate(`/quickquiz/${roomNumber}?guest=true&room=${roomNumber}${topicParam}`);
  };

  if (joinAsGuest) {
    return <QuickQuizGame initialGuestName={guestName} />;
  }

  return (
    <div className="quick-quiz-container">
      <h1>Join Quick Quiz Game</h1>
      
      <div className="invite-card">
        <div className="invite-header">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 20H7C4.79086 20 3 18.2091 3 16V8C3 5.79086 4.79086 4 7 4H17C19.2091 4 21 5.79086 21 8V16C21 18.2091 19.2091 20 17 20Z" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 8L12 14L21 8" stroke="#3498db" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <h2>You've been invited to a quiz!</h2>
        </div>
        
        <div className="invite-content">
          <p>You've been invited to join a Quick Quiz game. Enter your name to get started!</p>
          
          <div className="invite-details">
            <div className="detail-item">
              <span className="detail-label">Room:</span>
              <span className="detail-value">{roomNumber}</span>
            </div>
            {topic_id && (
              <div className="detail-item">
                <span className="detail-label">Topic:</span>
                <span className="detail-value">{topic_id}</span>
              </div>
            )}
          </div>
          
          <div className="guest-form">
            <label htmlFor="guest-name">Your Name:</label>
            <input
              type="text"
              id="guest-name"
              value={guestName}
              onChange={(e) => setGuestName(e.target.value)}
              placeholder="Enter your name"
              maxLength={20}
            />
            {errorMessage && <p className="error-message">{errorMessage}</p>}
          </div>
        </div>
        
        <div className="invite-actions">
          <button 
            className="primary-button"
            onClick={handleJoinAsGuest}
          >
            Join as Guest
          </button>
          <button 
            className="secondary-button"
            onClick={handlePlayDirectly}
          >
            Play Directly
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuickQuizInvite; 